import React, { useState, useEffect } from "react";
import io from "socket.io-client";
import ConversationsList from "../components/ConversationsList";
import ChatWindow from "../components/ChatWindow";
import ConversationTagsSidebar from "../components/ConversationTagSidebar";

// Configuración de la URL del servidor Socket.IO y API desde variables de entorno
const socketUrl = process.env.REACT_APP_SOCKET_URL; // URL de tu servidor Socket.IO
const socket = io(socketUrl);
const API_URL = process.env.REACT_APP_API_URL;

// 👇 Agrega esto temporalmente para depurar
socket.onAny((eventName, ...args) => {
  console.log(`[Socket Entrante] Evento: "${eventName}"`, args);
});

function Chat({showOldConversations}) {

  
  console.log("El valor de showOldConversations es:", showOldConversations);
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [tags, setTags] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const [quickNotes, setQuickNotes] = useState([]);

  let conversationsFiltered = [];
  // filtras las conversaciones dentro de las ultimas 48 horas dependiendo del valor de showOldConversations
  if (showOldConversations === true) {
    console.log("Mostrando todas las conversaciones sin filtrar por fecha.");
    conversationsFiltered = conversations; // No filtramos, mostramos todas
  } else if (showOldConversations === false) {
    console.log(
      "Mostrando solo conversaciones con mensajes en las últimas 48 horas.",
    );
    conversationsFiltered = conversations.filter((conv) => {
      const lastMessageTime = new Date(conv.last_message_at).getTime();
      const now = Date.now();
      const hours48 = 48 * 60 * 60 * 1000;
      return now - lastMessageTime <= hours48;
    });
  }



  // ESTA ES LA FUNCIÓN CLAVE PARA ELIMINAR UNA ETIQUETA DEL ESTADO LOCAL DESPUÉS DE ELIMINARla EN LA BASE DE DATOS
  const handleRemoveTagState = (tagIdToRemove) => {
    // Filtramos el array de etiquetas actual, quitando la que acabamos de eliminar
    setTags((prevTags) => prevTags.filter((tag) => tag.id !== tagIdToRemove));
  };

  // Cargar conversaciones iniciales
  useEffect(() => {
    // 1. Obtenemos el usuario del localStorage
    const userStorage = localStorage.getItem("user");
    let userId = "";
    let userRole = "";

    if (userStorage) {
      try {
        // Convertimos el string JSON a un objeto y extraemos el id
        const userObj = JSON.parse(userStorage);
        userId = userObj.id;
        userRole = userObj.role;
      } catch (error) {
        console.error("Error al parsear el usuario de localStorage:", error);
      }
    }

    // 2. Construimos la URL dependiendo de si tenemos el userId y el role
    const urlConversations =
      userRole === "admin"
        ? `${API_URL}conversations` // Admin ve todas las conversaciones
        : `${API_URL}conversations?user_id=${userId}`; // Usuarios normales solo ven sus conversaciones

    const urlQuickNotes = userRole === "admin"
      ? `${API_URL}quick-notes` // Admin ve todas las notas rápidas
      : `${API_URL}quick-notes/user/${userId}`; // Usuarios normales solo ven sus notas rápidas

    // cargamos las conversaciones al entrar por primera vez
    fetch(urlConversations)
      .then((res) => res.json())
      .then((data) => setConversations(data)) // Ajusta esto según la estructura de tu respuesta
      .catch((err) => console.error("Error al cargar conversaciones:", err));

    // cargamos las etiquetas al select para etiquetar
    fetch(`${API_URL}tags`)
      .then((res) => res.json())
      .then((data) => setAvailableTags(data))
      .catch((err) =>
        console.error("Error al cargar el select con las etiquetas:", err),
      );

    // cargamos las notas rapidas para mostrarlas en el sidebar de notas rapidas
    fetch(urlQuickNotes)
      .then((res) => res.json())
      .then((data) => setQuickNotes(data))
      .catch((err) => console.error("Error al cargar notas rápidas:", err));
  }, []);

  // Escuchar por nuevos mensajes y actualizaciones de conversación en tiempo real usando WebSockets (Socket.IO)
  useEffect(() => {
    const userStorage = localStorage.getItem("user");
    let userId = "";
    let userRole = "";

    if (userStorage) {
      try {
        const userObj = JSON.parse(userStorage);
        userId = userObj.id;
        userRole = userObj.role;
      } catch (error) {
        console.error("Error al parsear el usuario de localStorage:", error);
      }
    }
    // Escucha por nuevos mensajes para la conversación activa y actualiza la lista de mensajes en tiempo real
    const handleNewMessage = ({ conversationId, message }) => {
      // Validamos que el mensaje entrante pertenece a la conversación actualmente seleccionada para decidir si actualizamos la lista de mensajes en tiempo real
      // console.log(
      //   "entramoste en handleNewMessage con conversationId:",
      //   conversationId,
      //   "y message:",
      //   message,
      // );
      if (
        selectedConversation &&
        String(selectedConversation.id) === String(conversationId)
      ) {
        // console.log(
        //   "El mensaje entrante pertenece a la conversación activa. Actualizando lista de mensajes.",
        // );
        setMessages((prevMessages) => [...prevMessages, message]);
      } else {
        console.log(
          "El mensaje entrante NO pertenece a la conversación activa. No actualizamos lista de mensajes.",
        );
      }
    };

    // Escucha por actualizaciones en la lista de conversaciones (para actualizar el último mensaje y reordenar la lista)
    const handleUpdateConversation = (updatedConversation) => {
      setConversations((prev) => {
        //validamos si el user_id del mensaje entrante coincide con el user_id del localStorage para evitar actualizar la lista de conversaciones con mensajes que no pertenecen al usuario autenticado

        if (userRole === "admin") {
          // Si el usuario es admin, no filtramos por user_id porque el admin puede ver todas las conversaciones
          console.log("Usuario admin, no filtramos por user_id");
        } else if (
          updatedConversation &&
          updatedConversation.user_id !== userId
        ) {
          console.warn(
            "Mensaje entrante para conversación que no pertenece al usuario autenticado. Ignorando actualización.",
          );
          return prev; // No actualizamos la lista si el mensaje no es para el usuario autenticado
        }

        console.log(
          "Actualizando conversación en la lista con los datos entrantes:",
          updatedConversation,
        );
        
        const existingConv = prev.find(
          (c) => String(c.id) === String(updatedConversation.id),
        );
        let newConversations;
        if (existingConv) {
          // Actualizar conversación existente (esto actualizará el último mensaje y timestamp) y luego reordenar la lista para que la conversación actualizada suba al top si es la más reciente
          newConversations = prev.map((c) =>
            String(c.id) === String(updatedConversation.id)
              ? { ...c, ...updatedConversation }
              : c,
          );
        } else {
          // Agregar nueva conversación si no existe (esto puede suceder si el webhook recibe un mensaje de una conversación que aún no está en la lista) y luego reordenar la lista para que la nueva conversación suba al top si es la más reciente
          newConversations = [updatedConversation, ...prev];
        }
        // Reordenar por el timestamp más reciente para que la conversación con el último mensaje más reciente suba al top de la lista
        return newConversations.sort(
          (a, b) => new Date(b.last_message_at) - new Date(a.last_message_at),
        );
      });
    };

    // Registrar los listeners de WebSocket cuando el componente se monta o cambia la conversación seleccionada (para asegurarnos de que solo escuchamos mensajes relevantes)
    socket.on("newMessage", handleNewMessage);
    socket.on("updateConversation", handleUpdateConversation);

    // Limpieza al desmontar el componente o cambiar la conversación seleccionada (para evitar escuchar mensajes irrelevantes)
    return () => {
      socket.off("newMessage", handleNewMessage);
      socket.off("updateConversation", handleUpdateConversation);
    };
  }, [selectedConversation]); //

  // Cargar mensajes cuando se selecciona una conversación
  useEffect(() => {
    if (selectedConversation) {
      fetch(`${API_URL}messages/${selectedConversation.id}`)
        .then((res) => res.json())
        .then((data) => setMessages(data))
        .catch((err) => console.error("Error al cargar mensajes:", err));
    } else {
      setMessages([]);
    }
  }, [selectedConversation]);

  // Cargar etiquetas cuando se selecciona una conversación
  useEffect(() => {
    if (selectedConversation) {
      fetch(`${API_URL}conversations/${selectedConversation.id}/tags`)
        .then((res) => res.json())
        .then((data) => setTags(data))
        .catch((err) => console.error("Error al cargar etiquetas:", err));
    } else {
      setTags([]);
    }
  }, [selectedConversation]);

  // ESTA ES LA FUNCIÓN CLAVE
  const handleTagAdded = (nuevaEtiqueta) => {
    // Actualizamos el estado agregando la nueva etiqueta al final del array.
    // Verificamos primero que no exista para evitar duplicados en la UI.
    setTags((prevTags) => {
      const yaExiste = prevTags.some((tag) => tag.id === nuevaEtiqueta.id);
      if (yaExiste) 
      {
        console.log("La etiqueta ya existe en el estado, no la agregamos de nuevo:");
        return prevTags;
      }

      console.log("Agregando nueva etiqueta al estado:", nuevaEtiqueta);

      return [...prevTags, nuevaEtiqueta];
    });
  };

  // Maneja la selección de una conversación y carga sus mensajes (esto también se puede usar para actualizar el estado de la conversación seleccionada en la lista, por ejemplo, para marcarla como leída)
  const handleSelectConversation = (conversation) => {
    setSelectedConversation(conversation);
  };

  // Renderiza la lista de conversaciones y la ventana de chat para la conversación seleccionada
  return (
    <div className="chat-container">
      <ConversationsList
        availableTags={availableTags}
        conversations={conversationsFiltered}
        allConversations={conversations}
        onSelectConversation={handleSelectConversation}
        selectedConversationId={
          selectedConversation ? selectedConversation.id : null
        }
      />
      <ChatWindow
        conversation={selectedConversation}
        messages={messages}
        setMessages={setMessages}
        quickNotes={quickNotes}
      />

      <ConversationTagsSidebar
        tags={tags}
        availableTags={availableTags}
        conversationId={selectedConversation ? selectedConversation.id : null}
        onTagAdded={handleTagAdded}
        onTagRemoved={handleRemoveTagState}
      />
    </div>
  );
}

export default Chat;
